import { useApi } from '../useApi';
import { baseUrl, ServiceName } from '../urlHelper';
import { CONSTANTS_PATH } from '../constant';
import { prepareAuthHeaders } from '../requestsHelper';

export const useDeleteUserAPI = () => {
    const { apiCall } = useApi();

    const deleteUser = async (userId: string): Promise<string> => {
        const url: string = `${baseUrl(ServiceName.USERS)}${CONSTANTS_PATH.USER_SERVICE}/${userId}`;

        return await apiCall<string>(
            url,
            {
                method: 'DELETE',
                headers: {
                    ...prepareAuthHeaders(),
                },
            },
            `User with id = ${userId} deleted successfully!`
        );
    };

    return { deleteUser };
};